import {useLegacyConfig} from '@aboutyou/config';
import {MaybeTokenOrSessionId} from '../user-state/userStore/user.selector';

export const useDefaultHeadersWithToken = (session: MaybeTokenOrSessionId) => {
  const {authTokenName} = useLegacyConfig();
  if (!session) {
    return null;
  }
  return Object.assign(
    {'Content-Type': 'application/json'},
    // x-auth-token for desktop x-token for mobile
    {[authTokenName]: session.resolvedId},
  );
};
